module.exports = __webpack_public_path__ + "img/comrades.30de5030.png";